var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_79_367)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.45825 9.04167C6.45825 10.412 7.0026 11.7261 7.97153 12.6951C8.94047 13.664 10.2546 14.2083 11.6249 14.2083C12.9952 14.2083 14.3094 13.664 15.2783 12.6951C16.2472 11.7261 16.7916 10.412 16.7916 9.04167C16.7916 7.67138 16.2472 6.35722 15.2783 5.38828C14.3094 4.41934 12.9952 3.875 11.6249 3.875C10.2546 3.875 8.94047 4.41934 7.97153 5.38828C7.0026 6.35722 6.45825 7.67138 6.45825 9.04167Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.875 27.125V24.5417C3.875 23.1714 4.41934 21.8572 5.38828 20.8883C6.35722 19.9193 7.67138 19.375 9.04167 19.375H14.2083C15.5786 19.375 16.8928 19.9193 17.8617 20.8883C18.8307 21.8572 19.375 23.1714 19.375 24.5417V27.125",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.6667 4.04291C21.7781 4.32746 22.7632 4.97381 23.4666 5.88006C24.1701 6.7863 24.5519 7.9009 24.5519 9.04812C24.5519 10.1953 24.1701 11.3099 23.4666 12.2162C22.7632 13.1224 21.7781 13.7688 20.6667 14.0533",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.125 27.125V24.5416C27.1184 23.4013 26.7348 22.2952 26.0339 21.3957C25.333 20.4961 24.3541 19.8538 23.25 19.5687",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_79_367"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 31,
    height: 31,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPt);
export default __webpack_public_path__ + "static/media/PT.f87546d364a6efac67b7ae53181081eb.svg";
export { ForwardRef as ReactComponent };